import type {KeyTextField, NumberField} from '@prismicio/client'
import {useLinkResolver} from 'prismicio'
import type {ButtonDocumentData} from 'prismicio-types'
import type {FC} from 'react'
import {ButtonV2} from 'src/common/ButtonV2'
import {StarRating} from 'src/common/StarRating'

type CTASectionProps = {
  ratingPlatform?: KeyTextField
  rating?: NumberField
  ctaTitle?: KeyTextField
  buttonData: ButtonDocumentData | null
  pageUid?: string
}

/**
 * CTA section with rating and call-to-action button
 */
export const CTASection: FC<CTASectionProps> = ({ratingPlatform, rating = 5, ctaTitle, buttonData, pageUid}) => {
  const {linkResolver} = useLinkResolver()

  if (!buttonData) {
    return null
  }

  const ratingValue = rating ?? 5

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-green-dark p-4">
      <div className="flex items-center gap-1.5">
        <span className="text-detail text-moss-white">{ratingPlatform}</span>
        <StarRating rating={ratingValue} color="Neon/300" />
        <span className="text-detail text-moss-white">{ratingValue}</span>
      </div>
      <p className="text-18 font-medium leading-[22px] text-moss-white">{ctaTitle}</p>
      {buttonData && (
        <ButtonV2
          variant="primary"
          className="text-button-xs !h-8 w-fit !p-3"
          trackingData={{
            mktgId: buttonData.marketing_id || 'blog-post-sidebar-button',
            location: 'blog-post-sidebar',
            dataType: 'primary-button',
            pageName: pageUid,
          }}
          href={linkResolver(buttonData.link)}
          newTrackingProps={{
            interaction: {
              element: `blog-post-sidebar-button`,
              elementText: buttonData.label || '',
              location: `blog-post-sidebar`,
            },
            pageType: 'blog_post',
          }}
        >
          {buttonData.label}
        </ButtonV2>
      )}
    </div>
  )
}
